import axiosClient from "./axiosClient";

export const obtenerConfigResetPassword = () =>
  axiosClient.get("/configuracion/reset-password").then((r) => r.data);

export const actualizarConfigResetPassword = (minutosExpiracion) =>
  axiosClient.post("/configuracion/reset-password", { minutosExpiracion }).then((r) => r.data);
